/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React from "react";

// styles and images
import triangle from "../../assets/triangle.jpg";
import styles from "./Header.module.css";

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

function About() {
  return (
    <div className={styles.text}>
      <p className={styles.textFirst}>
        טכנולוגיית אנימציה שפותחה בחברת פיקסאר, להפיכת מצולעים לצורות שנראות
        יותר עגלגלות, עדינות, נעימות ולעתים גם אנושיות.
      </p>
      <p>
        נדגים באמצעות הפיכת מרובע למצולע מרובה צלעות, כך שייראה עגלגל. נעשה זאת
        בכמה שלבים, ובכל שלב נכפיל את מספר הצלעות. אחרי מספר שלבים, המצולע ייראה
        יותר עגלגל.
      </p>
      <figure className={styles.descriptionImg}>
        <img src={triangle} alt="תאור המשוואה של פיקסאר" />
      </figure>
      <p>
        הנוסחה לחישוב קודקודי המצולע: נניח שיש לנו קודקוד B המחובר מצד אחד
        לקודקוד A ומצד שני לקודקוד C. נקרא לאמצע AB בשם A1, לאמצע BC בשם C1,
        ולנקודה חדשה שנוסיף בתוך המצולע בשם B1. נחשב את הקואורדינטות, כלומר ערכי
        x,y של הקודקודים החדשים, באמצעות הקואורדינטות של A,B,C על ידי הכפלה
        במספרים קבועים w1,w2,w3 שסכומם 1. למשל:
      </p>
      <p className={styles.formula}>
        A1&nbsp;=&nbsp;(A+B)/2, C1&nbsp;=&nbsp;(C+B)/2,
        B1&nbsp;=&nbsp;w1*A+w2*B+w3*C
      </p>

      <p>
        אם נשתמש בשיטה זו בכמה סבבים ובערכים מתאימים של המשקלים, הקודקודים
        יצטופפו ונקבל צורה עגלגלה. על ידי שליטה במשקלים נקבל צורות שונות. עבור
        w1=w3=1/8 נקבל צורה עגלגלה. עבור ערכים אחרים של משקלים נקבל צורות אחרות,
        לעתים גם פרקטליות. מוזמנים להציב ערכים באחוזים ל w1 ול w2 - בין 0 ל- 100
        ולנסות, למשל: 
      (25,75).
         אגב, w3 יכול להיות שלילי.
      </p>
    </div>
  );
}

export default About;
